import SetupSchoolContainer from './containers/SetupSchoolContainer';

export { SetupSchoolContainer };



// WEBPACK FOOTER //
// ./src/Onboarding/Setup/school/index.js